import dataRelay from 'data-relay'
import { Project } from './project'
import { getApi } from './api'
import { getStore } from './store'
import { userService } from './services/useUser'
export type IntentEvent =
  | 'WHATSAPP_LEARN_MORE'
  | 'WHATSAPP_PLAY_VIDEO'
  | 'WHATSAPP_VIEW'
  | 'WHATSAPP_ASIDE_CLICK'
  | 'WHATSAPP_BUSINESS_CARD_VIEW'
  | 'WHATSAPP_DASHBOARD_CLICK'

const STORAGE_KEY = 'tracked_intents'

async function getTrackedIntents(): Promise<Set<IntentEvent>> {
  try {
    const stored = await getApi().storage.getItem(STORAGE_KEY)
    return stored ? new Set(JSON.parse(stored)) : new Set()
  } catch {
    return new Set()
  }
}

async function markIntentTracked(event: IntentEvent) {
  try {
    const tracked = await getTrackedIntents()
    tracked.add(event)
    await getApi().storage.setItem(
      STORAGE_KEY,
      JSON.stringify(Array.from(tracked)),
    )
  } catch {}
}

export default async function (event: IntentEvent) {
  try {
    if (Project.dataRelay) {
      // Check if this intent has already been tracked in this session
      const trackedIntents = await getTrackedIntents()
      if (trackedIntents.has(event)) {
        return
      }

      const state = getStore().getState()
      const user = userService.endpoints.getUser.select({})(state as any)?.data
      const email = user?.username || user?.email

      dataRelay.sendEvent(
        {
          email,
          event,
          source:
            getApi().platform === 'web' ? 'Customer Portal' : 'Mobile App',
        },
        { apiKey: Project.dataRelay },
      )

      // Mark this intent as tracked
      await markIntentTracked(event)
    }
  } catch (e) {}
}
